import Produto from "model/administracao/cadastro/produto/Produto";
import { BaseEditModel } from "model/BaseEditModel";
import HelpdeskChamado from "./HelpdeskChamado";

export default class HelpdeskItemCompra implements BaseEditModel {

    id: number;
    codigo: string | null;
    key: string | null="";
    sequencial: number;
    produto: Produto;
    chamado : HelpdeskChamado;

    constructor(
        id = 0,
        codigo = null,
        sequencial = 0,
        produto = new Produto(),
        chamado = new HelpdeskChamado
    ) {
       this.id = id;
       this.codigo = codigo;
       this.sequencial = sequencial
       this.produto = produto;
       this.chamado = chamado;
    }
}